<template>
    <div>
        <Button type="primary" @click="selectAudioModal=true">选择图片</Button>
        <Modal
                @on-visible-change="visibleChange"
                class="dosion-audio"
                v-model="selectAudioModal"
                title="选择音频"
                :loading="true"
                width="1100"
                height="600" footer-hide>
            <Row>
                <Col span="6">
                    <Card style="width:273px;height: 600px;overflow: auto;" shadow>
                        <p slot="title">
                            音频分类
                        </p>
                        <Button @click="addFolder(null)" slot="extra" icon="md-add" type="primary" shape="circle">新增
                        </Button>
                        <el-tree :data="folderList" :props="defaultProps" default-expand-all highlight-current
                                 :expand-on-click-node="false" @node-click="treeClick">
                               <span class="folder-tree-node" slot-scope="{ node, data }">
                                <span>{{ node.label }}</span>
                                <span v-if="data.id!=0">
                                  <el-button
                                          type="text"
                                          size="mini"
                                          icon="el-icon-edit"
                                          @click.stop="addFolder(data)">
                                  </el-button>
                                  <el-button
                                          type="text"
                                          size="mini"
                                          icon="el-icon-delete"
                                          @click.stop="delFolder(data)">
                                  </el-button>
                                </span>
                               </span>
                        </el-tree>
                    </Card>
                </Col>
                <Col span="18">
                    <Card style="width:825px;height: 600px;" shadow>
                        <Spin size="large" fix v-if="loading">
                            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                            加载中...
                        </Spin>
                        <p slot="title">
                            {{typeTitle}}
                            <!--<el-checkbox v-model="isSelectAll" @change="selectAll" style="margin-left: 20px">全选
                            </el-checkbox>-->
                        </p>
                        <a slot="extra">
                            <div v-if="selectMusicList!=null&&selectMusicList.length>0">
                                <Button type="text" @click="clearSelect">取消选择</Button>
                                <Button icon="md-trash" type="error" shape="circle" @click="batchDelete">删除音频</Button>
                            </div>
                            <div v-else>
                                <Input v-model="query.original" type="text" suffix="ios-search" search
                                       @on-search="getFile"
                                       placeholder="请输入名称搜索" style="width: auto;margin-right: 10px"/>
                                <el-upload
                                        :action="uploadUrl()"
                                        :show-file-list="false"
                                        :data="uploadData"
                                        :before-upload="beforeUpload"
                                        :on-error="errorUpload"
                                        :headers="uploadHeader"
                                        accept="audio/*"
                                        multiple
                                        :on-success="handleAvatarSuccess" style="display: inline;">
                                    <Button icon="ios-cloud-upload-outline" type="primary" shape="circle">上传音频</Button>
                                </el-upload>
                            </div>
                        </a>
                        <div style="height: 510px;overflow: auto">
                            <el-checkbox-group v-model="selectMusicList">
                                <el-table
                                        :data="musicList"
                                        size="mini"
                                        style="width: 100%">
                                    <el-table-column
                                            label="音频名称" prop="title">
                                        <template slot-scope="scope">
                                            <el-checkbox :label="scope.row.id">
                                            <span v-if="music==null||scope.row.id != music.id"
                                                  v-text="scope.row.title"></span>
                                                <span v-else style="color:  rgb(65, 184, 131)"
                                                      v-text="scope.row.title"></span>
                                            </el-checkbox>
                                        </template>

                                    </el-table-column>

                                    <el-table-column label="操作" width="200" align="center">
                                        <template slot-scope="scope">
                                            <Icon type="md-play" v-if="music==null||scope.row.id != music.id"
                                                  style="font-size: 16px;cursor: pointer;margin-right: 5px"
                                                  @click="payer(scope.row)"/>
                                            <Icon type="md-pause" v-else
                                                  style="font-size: 16px;cursor: pointer;margin-right: 5px"
                                                  @click="pause(scope.row)"/>
                                            <Icon type="md-download"
                                                  style="font-size: 16px;cursor: pointer;margin-right: 5px"
                                                  @click="download(scope.row)"/>
                                            <Icon type="md-trash" style="font-size: 16px;cursor: pointer"
                                                  @click="delMusic(scope.row)"/>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-checkbox-group>
                            <Page style="float: left;margin-top: 5px;margin-left: 10px" v-if="count>0" transfer
                                  @on-change="pageChange"
                                  @on-page-size-change="sizeChange"
                                  :page-size="11"
                                  :page-size-opts="[11,22,44,88]"
                                  prev-text="上一页"
                                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>

                            <div style="clear: both"></div>
                        </div>
                    </Card>

                </Col>
            </Row>

            <aplayer v-if="music!=null" style="float: left;width: 500px" preload="auto" :music="music">
            </aplayer>
            <Button v-if="!hiedOk" @click="okSelect" type="primary" style="float: right;margin: 22px">确定</Button>
            <p v-if="selectMusicList!=null&&selectMusicList.length>0"
               style="float: right;margin: 10px;line-height: 56px">
                已选择
                <span style="color: #ed4014">{{selectMusicList.length}}</span> 个音频</p>
            <div style="clear: both"></div>
        </Modal>
    </div>
</template>
<style>
    .dosion-audio .ivu-modal-body {
        padding: 0px !important;
    }

    .dosion-audio .ivu-card-extra {
        top: 8px;
    }

    .folder-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
</style>
<script>
    import {addFolder, delFolder, folderList, updateFolder} from '@/api/system/folder'
    import {batchDeleteFile, fetchList} from '@/api/system/file'
    import dataUtils from '@/utils/dataUtils';
    import appUtils from '@/utils/appUtils';
    import Setting from '@/setting';
    import Aplayer from 'vue-aplayer'
    import $ from 'jquery'

    export default {
        components: {
            Aplayer
        },
        name: 'dosion-audio',
        props: {
            value: {
                type: Boolean
            },
            hiedOk: {
                type: Boolean
            }
        },
        data() {
            return {
                loading: false,//加载中
                site: {},//站点信息
                typeTitle: '全部分类',//分类标题
                folderList: [],//文件夹列表
                selectFolder: {},//选择的文件夹
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                fileList: [],//文件列表
                uploadData: {
                    'fileType': '1'
                },
                uploadHeader: {
                    Authorization: 'Bearer ' + dataUtils.getData(Setting.key.token)
                },
                selectMusicList: [],//选中的音频
                isSelectAll: false,//是否全选
                query: {
                    'folderId': null,
                    'original': null,
                    'type': 'AUDIO',
                    'thumbnail': false,
                    current: 1, // 当前页数
                    size: 11 // 每页显示多少条
                },
                music: null,
                musicList: [],
                count: 0,
                selectAudioModal: false
            }
        },
        computed: {},
        watch: {
            selectMusicList() {
                if (this.selectMusicList == null || this.selectMusicList.length <= 0) {
                    this.isSelectAll = false
                    return
                }
                if (this.selectMusicList.length == this.fileList.length) {
                    this.isSelectAll = true
                } else {
                    this.isSelectAll = false
                }
            },
            selectAudioModal(val) {
                if (val) {
                    this.selectMusicList = []
                    this.getFolder()
                }
            },
            value(val) {
                if (val) {
                    if (val) {
                        this.selectAudioModal = true
                    }
                }
            },
            deep: true
        },
        methods: {
            visibleChange(val) {
                this.$emit('input', val)
            },

            //上传地址
            uploadUrl() {
                return Setting.apiBaseURL + '/system/file/upload?folderId=' + this.selectFolder.id
            },
            //加载文件夹
            getFolder() {
                this.loading = true
                folderList({'type': '1'}).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.folderList = [{
                            id: 0,
                            name: '全部分类',
                            children: res.data
                        }]
                        this.selectFolder = this.folderList[0]
                        this.getFile()
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //获取文件
            getFile() {
                this.loading = true
                this.query.folderId = this.selectFolder.id == 0 ? null : this.selectFolder.id
                fetchList(this.query).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.fileList = res.data.records
                        this.count = res.data.total
                        this.musicList = []
                        dataUtils.each(res.data.records, (key, obj) => {
                            this.musicList.push({
                                id: obj.id,
                                title: obj.name,
                                artist: obj.createDate,
                                ext: obj.ext,
                                url: obj.url,
                                preload: 'auto'
                            })
                        })
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //添加文件夹
            addFolder(folder) {
                var folderModel = {
                    'type': '1',
                    'name': null
                }
                if (folder != null) {
                    var model = JSON.parse(JSON.stringify(folder))
                    folderModel.id = model.id
                    folderModel.name = model.name
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: folderModel.name,
                                autofocus: true,
                                placeholder: '请输入文件夹名称'
                            },
                            on: {
                                input: (val) => {
                                    folderModel.name = val
                                }
                            }
                        })
                    },
                    loading: true,
                    onOk: () => {
                        if (folderModel.id == null) {
                            addFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        } else {
                            updateFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        }
                    }
                })
            },
            //删除文件夹
            delFolder(folder) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定删除文件夹？</p><p style="color: red">（删除后该分类图片自动移动到全部分类下）</p>',
                    loading: true,
                    onOk: () => {
                        delFolder(folder.id).then(res => {
                            if (res.state) {
                                this.getFolder()
                                appUtils.showSuccess(res.msg)
                                this.selectMusicList = []
                            } else {
                                appUtils.showError(res.msg)
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //上传之前
            beforeUpload(file) {
                this.loading = true
            },
            //上传失败
            errorUpload(err, file, fileList) {
                appUtils.showError(err)
                this.loading = false
            },
            //上传成功
            handleAvatarSuccess(res, file) {
                if (res.state) {
                    appUtils.showSuccess('上传成功！')
                    this.getFile()
                } else {
                    if (res.code == 1001) {
                        dataUtils.removeAllData()
                        location.reload()
                    } else {
                        appUtils.showError(res.msg)
                        this.loading = false
                    }
                }
            },
            //树节点点击
            treeClick(data, node, el) {
                if (this.selectFolder.id != data.id) {
                    this.selectFolder = data
                    this.typeTitle = data.name
                    this.getFile()
                    this.selectMusicList = []
                }
            },
            //取消音频选择
            clearSelect() {
                this.selectMusicList = []
            },
            //批量删除
            batchDelete() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定删除选择的音频？',
                    loading: true,
                    onOk: () => {
                        if (this.selectMusicList == null || this.selectMusicList.length <= 0) {
                            appUtils.showError('请选择要删除的音频！')
                            return
                        }
                        batchDeleteFile(this.selectMusicList.toString()).then(res => {
                            if (res.state) {
                                appUtils.showSuccess('删除音频成功！')
                                this.getFile()
                                this.selectMusicList = []
                            } else {
                                appUtils.showError('删除音频失败！')
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //确认选择
            okSelect() {
                var selectAudio = []
                dataUtils.each(this.selectMusicList, (k, o) => {
                    var arr = this.fileList.filter(t => t.id == o)
                    if (arr != null && arr.length > 0) {
                        selectAudio.push(arr[0])
                    }
                })
                this.$emit('select', selectAudio)
                this.selectMusicList = []
                this.selectAudioModal = false
            },
            //全选
            selectAll(val) {
                this.selectMusicList = []
                dataUtils.each(this.fileList, (key, obj) => {
                    this.selectMusicList.push(obj.id)
                })
            },
            //删除音频
            delMusic(row) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定删除音频？',
                    loading: true,
                    onOk: () => {
                        batchDeleteFile(row.id).then(res => {
                            if (res.state) {
                                appUtils.showSuccess('删除音频成功！')
                                this.getFile()
                                this.selectMusicList = []
                            } else {
                                appUtils.showError('删除音频失败！')
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            download(row) {
                window.open(row.url)
            },
            //播放音频
            payer(row) {
                this.music = row
                this.$nextTick(() => {
                    if ($('.aplayer-button').find('.aplayer-icon-play').length <= 0) {
                        $('.aplayer-button').find('.aplayer-icon-pause').click()
                    }
                    $('.aplayer-button').find('.aplayer-icon-play').click()
                })
            },
            //停止播放
            pause(row) {
                this.music = null
            },
            // 页数发生改变
            pageChange(val) {
                this.query.current = val
                this.getFile()
            },
            // 每页显示条数发生改变
            sizeChange(val) {
                this.query.size = val
                this.query.current = 1
                this.getFile()
            }
        },
        mounted() {
            //this.site = dataUtils.getData(config.key.site)
            //this.uploadData['site.id'] = this.site.id
        }
    }
</script>
